import { StoryCard } from '../../services';

interface DeleteCommentArgs {
  card: StoryCard;
  commentId: number;
  repliesCount: number;
  parentId?: number;
}

export const deleteCommentReducer = ({
  card,
  commentId,
  repliesCount,
  parentId,
}: DeleteCommentArgs) => {
  const { comments } = card;

  if (parentId) {
    const parentComment = comments.find(({ id }) => id === parentId);

    if (parentComment) {
      const { replies } = parentComment;
      const replyIndex = replies.findIndex(({ id }) => id === commentId);

      if (replyIndex !== -1) {
        replies.splice(replyIndex, 1);
        parentComment.repliesCount--;
      }
    }

    card.commentsCount--;
    return;
  }

  const commentIndex = comments.findIndex(({ id }) => id === commentId);

  if (commentIndex !== -1) {
    comments.splice(commentIndex, 1);
  }

  card.commentsRootCount--;
  card.commentsCount -= repliesCount + 1;
};
